export const professions = {
  french: [
    {
      id: 13,
      name: "Acheteur"
    },
    {
      id: 25,
      name: "Actuaire"
    },
    {
      id: 27,
      name: "Agent d'Assurance"
    },
    {
      id: 26,
      name: "Analyste Financier"
    },
    {
      id: 6,
      name: "Architecte"
    },
    {
      id: 23,
      name: "Assistant Social"
    },
    {
      id: 21,
      name: "Assitant(e) Administratif (ive)"
    },
    {
      id: 19,
      name: "Auditeur"
    },
    {
      id: 29,
      name: "Biologiste"
    },
    {
      id: 14,
      name: "Chargé de Communication"
    },
    {
      id: 7,
      name: "Chef de Chantier"
    },
    {
      id: 11,
      name: "Chef de projet"
    },
    {
      id: 24,
      name: "Chercheur"
    },
    {
      id: 30,
      name: "Chimiste"
    },
    {
      id: 15,
      name: "Commercial"
    },
    {
      id: 43,
      name: "Compliance Officer"
    },
    {
      id: 20,
      name: "Comptable"
    },
    {
      id: 16,
      name: "Consultant"
    },
    {
      id: 42,
      name: "Data Analyst"
    },
    {
      id: 8,
      name: "Designer"
    },
    {
      id: 33,
      name: "Développeur IT"
    },
    {
      id: 9,
      name: "Electricien"
    },
    {
      id: 28,
      name: "Fiscaliste"
    },
    {
      id: 41,
      name: "Gestionnaire de Paie "
    },
    {
      id: 34,
      name: "Graphiste"
    },
    {
      id: 10,
      name: "Ingénieur"
    },
    {
      id: 32,
      name: "IT Analyste"
    },
    {
      id: 22,
      name: "Juriste"
    },
    {
      id: 38,
      name: "Logisticien"
    },
    {
      id: 45,
      name: "Marketeer"
    },
    {
      id: 39,
      name: "Mécanicien"
    },
    {
      id: 17,
      name: "Product Manager"
    },
    {
      id: 18,
      name: "Publicitaire"
    },
    {
      id: 40,
      name: "Recruteur"
    },
    {
      id: 44,
      name: "Supply Chain Spécialiste"
    },
    {
      id: 31,
      name: "Technicien"
    },
    {
      id: 36,
      name: "Technicien Réseau"
    },
    {
      id: 12,
      name: "Traducteur / Interprète"
    },
    {
      id: 35,
      name: "UX / UI Spécialiste"
    },
    {
      id: 37,
      name: "Webdesigner"
    }
  ],
  dutch: [
    {
      id: 13,
      name: "Aankoper"
    },
    {
      id: 25,
      name: "Actuaris"
    },
    {
      id: 21,
      name: "Administratief Bediende"
    },
    {
      id: 6,
      name: "Architect"
    },
    {
      id: 19,
      name: "Auditor"
    },
    {
      id: 29,
      name: "Bioloog"
    },
    {
      id: 20,
      name: "Boekhouder"
    },
    {
      id: 30,
      name: "Chemicus"
    },
    {
      id: 14,
      name: "Communicatie Specialist"
    },
    {
      id: 43,
      name: "Compliance Officer"
    },
    {
      id: 16,
      name: "Consultant"
    },
    {
      id: 42,
      name: "Data Analyst"
    },
    {
      id: 8,
      name: "Designer"
    },
    {
      id: 9,
      name: "Elektricien"
    },
    {
      id: 26,
      name: "Financieel Analist"
    },
    {
      id: 28,
      name: "Fiscaal Specialist"
    },
    {
      id: 34,
      name: "Grafisch Ontwerper"
    },
    {
      id: 10,
      name: "Ingenieur"
    },
    {
      id: 32,
      name: "IT Analist"
    },
    {
      id: 33,
      name: "IT Ontwikkelaar"
    },
    {
      id: 22,
      name: "Jurist"
    },
    {
      id: 38,
      name: "Logistiek Medewerker"
    },
    {
      id: 45,
      name: "Marketing Specialist"
    },
    {
      id: 39,
      name: "Mechanieker"
    },
    {
      id: 36,
      name: "Netwerkbeheerder"
    },
    {
      id: 41,
      name: "Payroll Specialist"
    },
    {
      id: 17,
      name: "Product Manager"
    },
    {
      id: 11,
      name: "Project Manager"
    },
    {
      id: 18,
      name: "Reclame Specialist"
    },
    {
      id: 40,
      name: "Recruiter"
    },
    {
      id: 24,
      name: "Researcher"
    },
    {
      id: 23,
      name: "Sociaal werker"
    },
    {
      id: 44,
      name: "Supply Chain Specialist"
    },
    {
      id: 31,
      name: "Technieker"
    },
    {
      id: 35,
      name: "UX / UI Specialist"
    },
    {
      id: 15,
      name: "Verkoper"
    },
    {
      id: 12,
      name: "Vertaler / Tolk"
    },
    {
      id: 27,
      name: "Verzekeringsagent"
    },
    {
      id: 37,
      name: "Webdesigner"
    },
    {
      id: 7,
      name: "Werfleider"
    }
  ],
  english: [
    {
      id: 20,
      name: "Accountant"
    },
    {
      id: 25,
      name: "Actuary"
    },
    {
      id: 21,
      name: "Administraive Employee"
    },
    {
      id: 18,
      name: "Advertising Specialist"
    },
    {
      id: 6,
      name: "Architect"
    },
    {
      id: 19,
      name: "Auditor"
    },
    {
      id: 29,
      name: "Biologist"
    },
    {
      id: 13,
      name: "Buyer"
    },
    {
      id: 30,
      name: "Chemist"
    },
    {
      id: 14,
      name: "Communication Specialist"
    },
    {
      id: 43,
      name: "Compliance Officer"
    },
    {
      id: 16,
      name: "Consultant"
    },
    {
      id: 42,
      name: "Data Analyst"
    },
    {
      id: 8,
      name: "Designer"
    },
    {
      id: 9,
      name: "Electrician"
    },
    {
      id: 10,
      name: "Engineer"
    },
    {
      id: 26,
      name: "Financial Analyst"
    },
    {
      id: 34,
      name: "Graphic Designer"
    },
    {
      id: 27,
      name: "Insurance Agent"
    },
    {
      id: 32,
      name: "IT Analyst"
    },
    {
      id: 33,
      name: "IT Developper"
    },
    {
      id: 22,
      name: "Lawyer"
    },
    {
      id: 38,
      name: "Logistician"
    },
    {
      id: 45,
      name: "Marketing Specialist"
    },
    {
      id: 39,
      name: "Mechanic "
    },
    {
      id: 36,
      name: "Network Technician"
    },
    {
      id: 41,
      name: "Payroll Specialist"
    },
    {
      id: 17,
      name: "Product Manager"
    },
    {
      id: 11,
      name: "Project Manager"
    },
    {
      id: 40,
      name: "Recruiter"
    },
    {
      id: 24,
      name: "Researcher"
    },
    {
      id: 15,
      name: "Sales"
    },
    {
      id: 7,
      name: "Site Manager"
    },
    {
      id: 23,
      name: "Social Worker"
    },
    {
      id: 44,
      name: "Supply Chain Specialist"
    },
    {
      id: 28,
      name: "Tax Specialist"
    },
    {
      id: 31,
      name: "Technician"
    },
    {
      id: 12,
      name: "Translator / Interpreter"
    },
    {
      id: 35,
      name: "UX / UI Specialist"
    },
    {
      id: 37,
      name: "Webdesigner"
    }
  ]
}